import React from 'react'
import SetLocation from './SetLocation'
import CouponApply from './CouponApply'
import OrderDetail from './OrderDetail'
import { useSelector } from 'react-redux';

function BucketCartItems(props:any) {
    const orderType = useSelector((state: any) => state.payment.orderType);
    const deliveryfee = useSelector((state: any) => state.store.deliveryfee);
    const pos_fee = useSelector((state: any) => state.store.pos_fee);
    const storeSelected = useSelector((state: any) => state.store.storeSelected);
    return (
        <div>
           <OrderDetail orderType={orderType} deliveryfee={deliveryfee} pos_fee={pos_fee} storeSelected={storeSelected}/>
        </div>
    )
}
export default BucketCartItems;
